import React from 'react';

import { Icon, Label, Text, Link } from 'Modules/ui2/components';
import warning from 'Modules/ui2/icons/warning.sprite.svg';
import help from 'Modules/ui2/icons/help.sprite.svg';
import { cryptoProPluginAbout } from 'Modules/business/cryptoprofiles';

import styles from '../common.module.scss';


export const PlatformNotSupportedComponent = ({ t }) => (
    <>
        <Icon icon={warning} className={styles.errorIcon} size='48' />
        <Label component='h3' weight='demibold' textSize='21-24'>
            {t('platform.title')}
        </Label>
        <Text component='p' textSize='18'>
            {t('platform.description')}
        </Text>
        <Text component='p' textSize='18'>
            {t('platform.requirements')}
        </Text>
        <Link href='mailto:help@cfahub.ru' icon={help} style={{ marginTop: 32, color: '#00D6D6' }}>
            help@cfahub.ru
        </Link>
    </>
);

export const BrowserNotSupportedComponent = ({ t }) => (
    <>
        <Icon icon={warning} className={styles.errorIcon} size='48' />
        <Label component='h3' weight='demibold' textSize='21-24'>
            {t('browser.title')}
        </Label>
        <Text component='p' textSize='18'>
            {t('browser.description', { link: cryptoProPluginAbout })}
        </Text>
    </>
);
